/**
 * @file client.js
 * @description Axios HTTP client with request/response interceptors.
 *              Automatically attaches JWT auth token from localStorage,
 *              unwraps response data, and handles error logging.
 */
import axios from 'axios';

/** Base API URL — reads from .env, falls back to the production server */
const baseURL = process.env.REACT_APP_API_URL || 'https://api.mtandtiot.in/api';

const client = axios.create({
    baseURL,
    timeout: 30000, // Increased timeout
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor to add auth token
client.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['x-auth-token'] = token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
client.interceptors.response.use(
    (response) => response.data,
    (error) => {
        if (error.response) {
            console.error('API Error Status:', error.response.status);
            if (error.response.status === 401) {
                console.warn('Unauthorized access - potential token expiry');
                // Auto-redirect to login screen to prevent silent failures
                localStorage.removeItem('token');
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Request setup error:', error.message);
        }
        return Promise.reject(error);
    }
);

// Helper to set token manually
client.setAuthToken = (token) => {
    if (token) {
        client.defaults.headers.common['x-auth-token'] = token;
    } else {
        delete client.defaults.headers.common['x-auth-token'];
    }
};

export default client;
